let apiKey = $('[data-api-key]').attr('data-api-key');

const facilityPill = ({facilityType, facilityColor}) => `
    <span class="${facilityColor}">${facilityType} </span>
`;

const locationItem = ({ name, address, phone, latLong, facilities }) => `
    <li class="loc-results__item">
        <div class="loc-results__map-image">
            <img src="https://maps.googleapis.com/maps/api/staticmap?center=${latLong}&zoom=14&size=400x400&key=${apiKey}" />
        </div>
        <div class="loc-results__content">
            <div class="loc-results__name">${name}</div>
            <div class="loc-results__address">${address}</div>
            ${facilities ? `<div class="loc-results__facilities">${facilities}</div>` : ''}
        </div>
        <div class="loc-results__actions">
            <div class="loc-results__action ${phone}">
                <img src="../../../images-2/Phone.svg" /> <a class="loc-results__actions__link" href="tel:${phone}">
                    ${phone}</a>
            </div>
            <div class="loc-results__action">
                <img src="../../../images-2/directions-icon.svg" /> <a class="loc-results__actions__link" target="_blank"
                    href="https://www.google.com/maps?saddr=My+Location&daddr=${latLong}">Get Directions</a>
            </div>
        </div>
    </li>
`;

export { locationItem, facilityPill };
